import { EmailOutlined } from '@mui/icons-material';
import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';
import { GoogleChatIcon, MicrosoftTeamsIcon, SlackOctothorpeIcon } from './channelIconSvgs';

export type ChatNotificationChannel = 'email' | 'googleChat' | 'teamsChat' | 'slackChat';

/** Slack small octothorpe: 15–20px tall with clear space around the mark. */
export const CHAT_CHANNEL_ICON_SIZE = 20;

const ICON_FRAME_SIZE = 28;

const iconFrameSx: SxProps<Theme> = {
  width: ICON_FRAME_SIZE,
  height: ICON_FRAME_SIZE,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

interface ChatNotificationChannelIconProps {
  channel: ChatNotificationChannel;
  size?: number;
}

const ChatNotificationChannelIcon: React.FC<ChatNotificationChannelIconProps> = ({
  channel,
  size = CHAT_CHANNEL_ICON_SIZE,
}) => {
  const svgProps = {
    width: size,
    height: size,
    style: { display: 'block' },
  };

  let icon: React.ReactNode;
  switch (channel) {
    case 'email':
      icon = <EmailOutlined sx={{ fontSize: size, color: 'text.secondary' }} aria-hidden />;
      break;
    case 'googleChat':
      icon = <GoogleChatIcon {...svgProps} />;
      break;
    case 'teamsChat':
      icon = <MicrosoftTeamsIcon {...svgProps} />;
      break;
    case 'slackChat':
      icon = <SlackOctothorpeIcon {...svgProps} />;
      break;
    default:
      icon = null;
  }

  return <Box sx={iconFrameSx}>{icon}</Box>;
};

export default ChatNotificationChannelIcon;
